// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qgyQ","colMin":"styles_colMin__36Vcz"};